// import React, { useEffect, useState, useRef } from "react";
// import { useHistory, Link } from "react-router-dom";
// import Slider from "react-slick";
// import { FiArrowLeft, FiArrowRight, FiMapPin } from "react-icons/fi";
// import { FaHeart, FaRegSnowflake, FaHome, FaRegBuilding } from "react-icons/fa";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// const OffersForYou = ({ data }) => {
//   const sliderRef = useRef(null);
//   const history = useHistory();
//   const [offers, setOffers] = useState([]);

//   useEffect(() => {
//     if (data && data.status === 1 && Array.isArray(data.data)) {
//       setOffers(data.data);
//     } else {
//       setOffers([]);
//     }
//   }, [data]);

//   if (offers.length === 0) return null;

//   // Pad offers so there are always at least 3 items for a 3-column layout
//   let displayOffers = [...offers];
//   while (displayOffers.length < 3) {
//     displayOffers = [...displayOffers, ...offers];
//   }

//   const settings = {
//     infinite: true, // Required for smooth autoplay and looping
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true, // Forced autoplay
//     autoplaySpeed: 4000,
//     pauseOnHover: true,
//     arrows: false,
//     cssEase: "ease-in-out",
//     responsive: [
//       {
//         breakpoint: 1280,
//         settings: { slidesToShow: 3, infinite: true, autoplay: true },
//       },
//       {
//         breakpoint: 1024,
//         settings: { slidesToShow: 3, infinite: true, autoplay: true },
//       },
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: Math.min(offers.length, 2), infinite: offers.length > 2, autoplay: offers.length > 2 },
//       },
//     ],
//   };

//   return (
//     <div className="bg-[#FAF8F5] py-5 px-3 sm:px-5 rounded-2xl font-sans">
//       {/* HEADER SECTION */}
//       <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-5">
//         <div className="flex flex-col">
//           {/* Logo mock (remove if handled by a parent component) */}
        

//           <h2 className="text-xl sm:text-2xl font-bold text-[#0B1E40] leading-tight">
//             Hot Deals &amp;{" "}
//             <span className="text-[#8e1616]">Exclusive Offers</span>
//           </h2>
//           <p className="text-gray-500 text-xs mt-0.5">
//             Limited-time property deals and special savings
//           </p>
//         </div>

//         {/* Navigation Buttons */}
//         <div className="flex items-center gap-3 w-full md:w-auto">
//           <button
//             className="bg-[#8e1616] text-white py-1.5 px-4 text-xs font-medium rounded-full flex items-center justify-center gap-2 hover:bg-[#6f1010] transition-colors w-full md:w-auto"
//             onClick={() => history.push("/all-offers")}
//           >
//             View All Offers <FiArrowRight />
//           </button>

//           <div className="hidden sm:flex gap-2">
//             <button
//               aria-label="Previous"
//               className="bg-white text-[#0B1E40] rounded-full h-8 w-8 flex items-center justify-center shadow-md hover:shadow-lg hover:bg-[#8e1616] hover:text-white transition-all cursor-pointer"
//               onClick={() => sliderRef.current?.slickPrev()}
//             >
//               <FiArrowLeft className="text-base" />
//             </button>
//             <button
//               aria-label="Next"
//               className="bg-white text-[#0B1E40] rounded-full h-8 w-8 flex items-center justify-center shadow-md hover:shadow-lg hover:bg-[#8e1616] hover:text-white transition-all cursor-pointer"
//               onClick={() => sliderRef.current?.slickNext()}
//             >
//               <FiArrowRight className="text-base" />
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* CAROUSEL SECTION */}
//       <div className="-mx-1.5">
//         <Slider key={displayOffers.length} ref={sliderRef} {...settings}>
//           {displayOffers.map((offer, index) => (
//             <div key={`${offer?._id || index}-${index}`} className="px-1.5 pt-1.5 pb-3">
//               <Link
//                 to={{
//                   pathname: `/offerdetail/${offer?.property_id || "#"}`,
//                   state: { offer },
//                 }}
//                 className="flex flex-col bg-white rounded-xl shadow-[0_3px_12px_rgba(0,0,0,0.05)] border border-gray-100 transition-transform hover:-translate-y-1 relative group"
//               >
//                 {/* 1. IMAGE AREA */}
//                 <div className="relative h-28 sm:h-32 w-full rounded-t-xl">
//                   <img
//                     src={
//                       offer?.offer_img
//                         ? `${process.env.REACT_APP_API_URL}${offer.offer_img}`
//                         : "/image/property-search.jpg"
//                     }
//                     alt={offer?.offer_name || "Project"}
//                     className="w-full h-full object-cover rounded-t-xl"
//                   />
//                   <div className="absolute inset-0 rounded-t-xl bg-gradient-to-t from-black/25 to-transparent pointer-events-none" />

//                   {/* Top Left Badge */}
//                   <div className="absolute top-2.5 left-2.5 max-w-[65%] bg-[#8e1616] text-white text-[10px] font-semibold py-0.5 px-2 rounded flex items-center gap-1 shadow-sm">
//                     <FaRegSnowflake className="flex-shrink-0 text-[10px]" />
//                     <span className="truncate">
//                       {offer?.offer_name || "Winter Offer"}
//                     </span>
//                   </div>

//                   {/* Top Right Heart (Favorite) */}
//                   <div
//                     className="absolute top-2.5 right-2.5 bg-white h-7 w-7 flex items-center justify-center rounded-full shadow-md z-10 cursor-pointer hover:scale-110 transition-transform"
//                     onClick={(e) => {
//                       e.preventDefault();
//                       e.stopPropagation();
//                     }}
//                   >
//                     <FaHeart className="text-[#8e1616] text-[10px]" />
//                   </div>

//                   {/* Bottom Right 'Save Up To' Box */}
//                   <div className="absolute -bottom-4 right-2.5 bg-[#FFF6DB] border border-[#F2D98F] text-center px-2 py-1 rounded-lg shadow-md z-10 w-20">
//                     <p className="text-[#8e1616] text-[8px] font-semibold leading-none mb-0.5">
//                       Save Up To
//                     </p>
//                     <p className="text-[#8e1616] text-sm font-extrabold leading-none mb-0.5">
//                       {offer?.discount_percentage || "20%"}
//                     </p>
//                     <p className="text-gray-600 text-[7px] leading-none">
//                       on Select
//                     </p>
//                   </div>
//                 </div>

//                 {/* 2. CONTENT AREA */}
//                 <div className="flex flex-col p-3 pt-5 bg-white rounded-b-xl">
//                   <div className="flex items-start gap-2.5 mb-3 min-h-[3rem]">
//                     <div className="bg-red-50 h-8 w-8 flex items-center justify-center rounded-md flex-shrink-0">
//                       <FaRegSnowflake className="text-[#8e1616] text-sm" />
//                     </div>
//                     <div className="min-w-0">
//                       <h3 className="text-sm font-bold text-[#0B1E40] leading-tight mb-0.5 line-clamp-1">
//                         {offer?.offer_name || "Winter Offer"}
//                       </h3>
//                       <p className="text-[11px] text-gray-600 leading-snug line-clamp-2">
//                         {offer?.offer_description ||
//                           "Special deals on residential & commercial properties this winter."}
//                       </p>
//                     </div>
//                   </div>

//                   {/* Footer Links / Categories */}
//                   <div className="flex items-center justify-between gap-1.5 pt-2.5 border-t border-gray-100">
//                     <div className="flex flex-wrap gap-x-2.5 gap-y-1 text-[#3F4E69]">
//                       <span className="flex items-center gap-1 text-[10px] font-medium">
//                         <FaHome className="text-[#8e1616] text-[10px]" /> Residential
//                       </span>
//                       <span className="flex items-center gap-1 text-[10px] font-medium">
//                         <FaRegBuilding className="text-[#8e1616] text-[10px]" /> Commercial
//                       </span>
//                     </div>

//                     <button className="flex-shrink-0 bg-[#8e1616] text-white text-[10px] font-medium px-2.5 py-1 rounded-full flex items-center gap-1 group-hover:bg-[#6f1010] transition-colors">
//                       Explore <FiArrowRight className="text-[10px]" />
//                     </button>
//                   </div>
//                 </div>
//               </Link>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// };

// export default OffersForYou;


import React, { useEffect, useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  FiArrowLeft,
  FiArrowRight,
  FiBriefcase,
  FiClock,
  FiGift,
  FiHeart,
  FiHome,
  FiTag,
} from "react-icons/fi";

const MAROON = "#8e1616";
const MAROON_DARK = "#6f1010";
const NAVY = "#0B1E40";

const keyframes = `
@keyframes off-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
}
@keyframes off-fade-up {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: none; }
}
.off-enter { animation: off-fade-up 0.6s cubic-bezier(0.22, 1, 0.36, 1) both; }
.off-float { animation: off-float 3s ease-in-out infinite; }
.off-slider .slick-list { padding: 6px 0 14px; }
.off-slider .slick-track { display: flex; }
.off-slider .slick-slide { height: inherit; }
.off-slider .slick-slide > div { height: 100%; }
`;

const OfferCard = ({ offer, index }) => {
  const [pulse, setPulse] = useState(false);
  const [liked, setLiked] = useState(false);

  const imageSrc = offer?.offer_img
    ? `${process.env.REACT_APP_API_URL}${offer.offer_img}`
    : "/image/property-search.jpg";
  const title = offer?.offer_name || "Winter Offer";
  const description =
    offer?.offer_description ||
    "Special deals on residential & commercial properties this winter.";
  const discount = offer?.discount_percentage || "20%";

  const handleLike = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLiked((v) => !v);
    setPulse(true);
    setTimeout(() => setPulse(false), 400);
  };

  return (
    <div className="h-full px-2 pt-3 pb-4 off-enter" style={{ animationDelay: `${index * 90}ms` }}>
      <Link
        to={{
          pathname: `/offerdetail/${offer?.property_id || "#"}`,
          state: { offer },
        }}
        className="group relative flex h-full flex-col rounded-2xl bg-white no-underline hover:no-underline shadow-[0_4px_16px_rgba(15,23,42,0.08)] transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(142,22,22,0.18)]"
      >
        {/* IMAGE */}
        <div className="relative h-36 overflow-hidden rounded-t-2xl">
          <img
            src={imageSrc}
            alt={title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

          {/* Offer name chip */}
          <div className="absolute left-3 top-3 flex max-w-[70%] items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[10px] font-semibold text-[#8e1616] shadow-md backdrop-blur">
            <FiGift className="flex-shrink-0 text-[11px]" />
            <span className="truncate">{title}</span>
          </div>

          {/* Like */}
          <button
            onClick={handleLike}
            aria-label="Save offer"
            className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-white/95 shadow-md transition-transform duration-300 hover:scale-110 active:scale-95"
          >
            <span className={`inline-flex ${pulse ? "off-float" : ""}`}>
              <FiHeart
                size={13}
                style={{
                  color: liked ? MAROON : "#64748b",
                  fill: liked ? MAROON : "transparent",
                  transition: "fill 0.3s, color 0.3s",
                }}
              />
            </span>
          </button>
        </div>

        {/* DISCOUNT MEDAL (overlaps image and body) */}
        <div className="absolute right-4 top-[7.25rem] z-10 flex h-16 w-16 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-gradient-to-br from-[#8e1616] to-[#b83232] text-white shadow-lg ring-4 ring-white transition-transform duration-500 group-hover:rotate-12 group-hover:scale-110">
          <span className="text-[8px] font-semibold uppercase tracking-wider opacity-90">Save</span>
          <span className="text-sm font-extrabold leading-none">{discount}</span>
        </div>

        {/* BODY */}
        <div className="relative flex flex-1 flex-col px-4 pb-4 pt-5">
          <h3 className="pr-16 text-sm font-bold leading-tight text-[#0B1E40] line-clamp-1 transition-colors duration-300 group-hover:text-[#8e1616]">
            {title}
          </h3>
          <p className="mt-1 text-[11px] leading-snug text-slate-500 line-clamp-2">
            {description}
          </p>

          {/* Limited time strip */}
          <div className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-md bg-[#FFF6DB] px-2 py-1 text-[10px] font-semibold text-[#8e1616]">
            <FiClock className="text-[10px]" /> Limited time deal
          </div>

          {/* Ticket divider with notches */}
          <div className="relative my-3">
            <div className="border-t-2 border-dashed border-slate-200" />
            <span className="absolute -left-6 -top-2 h-4 w-4 rounded-full bg-slate-100" />
            <span className="absolute -right-6 -top-2 h-4 w-4 rounded-full bg-slate-100" />
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between gap-2">
            <div className="flex flex-wrap gap-x-2.5 gap-y-1 text-[10px] font-medium text-slate-600">
              <span className="flex items-center gap-1">
                <FiHome className="text-[10px] text-[#8e1616]" /> Residential
              </span>
              <span className="flex items-center gap-1">
                <FiBriefcase className="text-[10px] text-[#8e1616]" /> Commercial
              </span>
            </div>

            <span className="flex flex-shrink-0 items-center gap-1 rounded-full bg-[#8e1616] px-3 py-1.5 text-[10px] font-semibold text-white transition-all duration-300 group-hover:bg-[#6f1010] group-hover:gap-2">
              <FiTag className="text-[10px]" /> Claim
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

const OffersForYou = ({ data }) => {
  const sliderRef = useRef(null);
  const history = useHistory();
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    if (data && data.status === 1 && Array.isArray(data.data)) {
      setOffers(data.data);
    } else {
      setOffers([]);
    }
  }, [data]);

  if (offers.length === 0) return null;

  // Pad offers so there are always at least 3 items for a 3-column layout
  let displayOffers = [...offers];
  while (displayOffers.length < 3) {
    displayOffers = [...displayOffers, ...offers];
  }

  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: false,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 3, infinite: true, autoplay: true },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, infinite: true, autoplay: true },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(offers.length, 2),
          infinite: offers.length > 2,
          autoplay: offers.length > 2,
        },
      },
    ],
  };

  return (
    <>
      <style>{keyframes}</style>

      <div className="bg-white py-5 px-3 sm:px-5 rounded-2xl font-sans">
        {/* HEADER */}
        <div className="mb-5 flex flex-col justify-between gap-4 md:flex-row md:items-center">
          <div className="flex flex-col">
            <span className="mb-1.5 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#8e1616]/10 px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-widest text-[#8e1616]">
              <FiGift className="text-[10px]" /> Deals of the season
            </span>
            <h2 className="text-xl sm:text-2xl font-bold leading-tight text-[#0B1E40]">
              Hot Deals &amp;{" "}
              <span className="text-[#8e1616]">Exclusive Offers</span>
            </h2>
            <p className="mt-0.5 text-xs text-slate-500">
              Limited-time property deals and special savings
            </p>
          </div>

          {/* Navigation */}
          <div className="flex w-full items-center gap-3 md:w-auto">
            <button
              className="group flex w-full items-center justify-center gap-2 rounded-full bg-[#8e1616] px-4 py-1.5 text-xs font-medium text-white shadow-sm transition-all duration-300 hover:bg-[#6f1010] hover:shadow-md active:scale-95 md:w-auto"
              onClick={() => history.push("/all-offers")}
            >
              View All Offers
              <FiArrowRight className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>

            <div className="hidden gap-2 sm:flex">
              <button
                aria-label="Previous"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#0B1E40] shadow-md transition-all duration-300 hover:scale-110 hover:bg-[#8e1616] hover:text-white hover:shadow-lg active:scale-90"
                onClick={() => sliderRef.current?.slickPrev()}
              >
                <FiArrowLeft className="text-base" />
              </button>
              <button
                aria-label="Next"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-white text-[#0B1E40] shadow-md transition-all duration-300 hover:scale-110 hover:bg-[#8e1616] hover:text-white hover:shadow-lg active:scale-90"
                onClick={() => sliderRef.current?.slickNext()}
              >
                <FiArrowRight className="text-base" />
              </button>
            </div>
          </div>
        </div>

        {/* CAROUSEL */}
        <div className="-mx-1.5">
          <Slider key={displayOffers.length} ref={sliderRef} {...settings} className="off-slider">
            {displayOffers.map((offer, index) => (
              <OfferCard
                key={`${offer?._id || index}-${index}`}
                offer={offer}
                index={index}
              />
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default OffersForYou;